export default __webpack_public_path__ + "static/the-sandbox-ca0971ae889f74d89a180bacfbd1ebeb.png";